export const accountCreditAllocationsStyle = {
  label: {
    sx: {
      color: '#130F35',
    },
  },
  Typography: {
    sx: {
      color: 'action.active',
      pt: 3,
      pb: 2,
    },
  },
} as const;
